import React, { useState } from 'react';
import Tabs from '../components/tabs';
import CategoryCards from '../components/categoryCards';
import '../css/main.css';

const Main = () => {
  const [activeTab, setActiveTab] = useState('Accommodation'); // Default tab

  return (
    <div className='explore'>
      <div className="explore-header">
        <span className="explore-eyebrow">Curated City Guide</span>
        <h1>Explore Our City</h1>
        <div className="divider-line"></div>
        <p>Explore new places, food, and culture around Kimberley</p>
      </div>
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <CategoryCards activeTab={activeTab} />
    </div>
  );
};

export default Main;
